/* eslint-disable camelcase */
/* eslint-disable react/no-unknown-property */
import React, { useState, useRef, useEffect, useContext } from 'react'
import { PopupCloseContext, UserInitalValue } from '../../shared/contexts/popupclose-context'
import { Link, useNavigate } from 'react-router-dom'
import Buttons from '../buttons/buttons'
// import { UserContext } from '../../shared/contexts/role-context'
import { AuthContext } from '../../shared/contexts/AuthContextProvider'
import { getInitials } from '../../Global'
import { useMsal } from '@azure/msal-react'
import ActionButton from '../buttons/newbutton'
import Popups from '../../components/popup/popupwithposition'

export default function HeaderProfile() {

  /** *** Responsive Popup Code Start*****/
  const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
  const profilePopupRef = useRef<any>(null)
  const {loginUserRoles,setLoginUserRoles,setAccessToken} = useContext(AuthContext)
  const { instance, accounts } = useMsal()

  console.log('In HeaderProfile, loginUserRoles is:', loginUserRoles)

  const logoutprofile = async()=> {
    setAccessToken(null)
    setLoginUserRoles([])
    sessionStorage.clear()
    localStorage.clear()
    instance.logoutRedirect()
      .then(() => {
        console.log('Logged out successfully')
      })
      .catch((error) => {
        console.error('Logout error', error)
      })
     setMultiplePopup('')
  }
  const profilePopupClick = (ele: string) => {
    setMultiplePopup((prevPopup: any) => (prevPopup === ele ? null : ele))
}

  if (!loginUserRoles || !loginUserRoles.name) {
    return null
  }

  return (
    <div className="Profile d-flex align-items-center h-100 p-2">
        <ActionButton 
        label={loginUserRoles.name} 
        name={getInitials(loginUserRoles?.name)}
        className='btn btn-xs font-14 profile-container p-relative d-flex align-items-center'
        icon={loginUserRoles?.name ? '' : 'icon-user-profile bold font-30 py-1'}
        type='button'
        aria-expanded={multiplePopup === 'profilePopup'}
        ref={profilePopupRef} 
        onClick={() => {
            profilePopupClick('profilePopup')
          }}
        />
      {multiplePopup === 'profilePopup' && (
        <Popups buttonRef={profilePopupRef} popupId="profilePopup" className="dropdown-popup popup-sm border-radius2 card shadow1 fade-in " popupContent={
          <>
            <div className='card card-lg'>
              <div className="card-header d-flex align-items-center border-bottom1">
                <div className='profile-container p-2 font-16 me-2'>{loginUserRoles.length == 0 ? <span className='icon-user-profile bold font-30 py-1'></span> : getInitials(loginUserRoles?.name)}</div>
                <div className='d-flex flex-column'>
                  {loginUserRoles.length == 0 ?
                    <h6 className='segoeui-semibold font-16 mb-1 subtitle-color1' tabIndex={0} aria-label='user Name'>User Name</h6>
                    : <h6 className='segoeui-semibold font-16 mb-1' tabIndex={0} aria-label={loginUserRoles?.name}>{loginUserRoles?.name}</h6>
                  }
                  <a href={'mailto:' + loginUserRoles?.unique_name} className="eMail text-break links font-14 links-over-underline segoeui-regular" title={loginUserRoles?.unique_name}>{loginUserRoles?.unique_name}</a>
                </div>
              </div>
              <div className="card-footer p-4 py-2">
                <Buttons
                  label="Logout"
                  className="segoeui-semibold font-14 p-0"
                  icon="icon-logout bold me-2 color-primary"
                  onClick={() => logoutprofile()}
                />
              </div>
            </div>
          </>
        } />)}
    </div>
  )
}


